'use strict';

define('vb/private/stateManagement/context/appPackageContext',[
  'vb/private/constants',
  'vb/private/stateManagement/context/flowContext',
  'vb/private/stateManagement/context/appPackageBaseContext',
], (Constants, FlowContext, AppPackageBaseContext) => {
  class AppPackageContext extends FlowContext {
    /**
     *
     * @param appPackage
     */
    constructor(appPackage) {
      super(appPackage);

      const propDescriptors = {
        global: {
          get() {
            const extensionApplication = appPackage.application.extensions[appPackage.extensionId];
            // There is always an application extension because the App UI can only be defined in an extension
            return extensionApplication.expressionContext.application;
          },
          configurable: true,
          enumerable: true,
        },
      };

      /**
       * $application.responsive.XXX
       * $application.user.XXX
       * $application.initParams.XXX
       * $application.currentPage.XXX
       * $application.deployment.XXX
       *
       * $application.info and $application.path are not defined here because
       * there are already defined in the super class FlowContext
       */
      [Constants.RESPONSIVE_CONTEXT,
        Constants.APPLICATION_USER_VARIABLE,
        Constants.INIT_PARAM_CONTEXT,
        Constants.CURRENT_PAGE_VARIABLE,
        Constants.DEPLOYMENT_CONSTANT,
      ].forEach((property) => {
        propDescriptors[property] = {
          get() {
            // builtins are not extendable, so directly retrieve the value from the application
            // expression context object
            return appPackage.application.expressionContext[property];
          },
          enumerable: true,
          configurable: true,
        };
      });

      Object.defineProperties(this, propDescriptors);
    }

    static get BaseContextType() {
      return AppPackageBaseContext;
    }

    static getAvailableContexts(appPackage) {
      const availableContexts = super.getAvailableContexts(appPackage);

      delete availableContexts.$flow;

      Object.defineProperties(availableContexts, {
        // Override the $global defined in ContainerContext to point to the extension application
        $global: {
          enumerable: true,
          configurable: true,
          // Retrieve the application extension with the same extension id
          get() {
            return appPackage.expressionContext.global;
          },
        },
      });

      return availableContexts;
    }
  }

  return AppPackageContext;
});

